import _ from 'lodash'
import { MutationTree } from 'vuex'
import { AuthState } from '@/modules/auth/store'
import JWTToken, {ActiveUser, User} from '@/modules/auth/types'

export enum MutationTypes {
    SetToken = 'setToken',
    SetUser  = 'setUser',
    SetActiveUsers = 'SET_ACTIVE_USERS',
    AddActiveUser = 'ADD_ACTIVE_USER',
    RemoveActiveUser = 'REMOVE_ACTIVE_USER',
    UpdateActiveUserField = 'UPDATE_ACTIVE_USER_FIELD',
    ToggleChangingActiveUser = 'TOGGLE_CHANGING_ACTIVE_USER',
    SetActiveUserToBeAuthenticated = 'SET_ACTIVE_USER_TO_BE_AUTHENTICATED',
}

const mutations: MutationTree<AuthState> = {

    /**
     * Registra el token de autorización en el estado
     */
    [MutationTypes.SetToken]: (state, payload: {token: JWTToken}) => {
        state.token = payload.token
    },

    /**
     * Registra el usuario actual en el estado
     */
    [MutationTypes.SetUser]: (state, user: User) => {
        state.user = user
    },

    [MutationTypes.SetActiveUsers]: (state, users: ActiveUser[]) => {
        state.activeUsers = users
    },

    [MutationTypes.AddActiveUser]: (state, user: ActiveUser) => {
        const index = state.activeUsers.findIndex(u => u.id === user.id)

        index === -1
            ? state.activeUsers.push(user)
            : state.activeUsers.splice(index, 1, user)
    },

    /**
     * @param state
     * @param id
     * @param field
     * @param value
     */
    [MutationTypes.UpdateActiveUserField]: (state, {id, field, value}: {id: number, field: string, value: any}) => {
        const user = state.activeUsers.find(u => u.id === id)
        if (!user) {
            throw new Error(`El usuario con id ${id} no existe como usuario activo de la aplicación`)
        }

        _.set(user, field, value)
    },

    /**
     * Activa o desactiva la opción que indica si la aplicación esta cambiando
     * de un usuario a otro
     *
     * @param state
     * @param changing
     */
    [MutationTypes.ToggleChangingActiveUser]: (state, changing: boolean) => {
        state.changingActiveUser = changing
    },

    [MutationTypes.SetActiveUserToBeAuthenticated]: (state, user: ActiveUser) => {
        state.activeUserToBeAuthenticated = user
    },

    [MutationTypes.RemoveActiveUser]: (state, id: number) => {
        const index = state.activeUsers.findIndex(u => u.id === id)
        if (index !== -1) {
            state.activeUsers.splice(index, 1)
        }
    },
}

export default mutations
